import React from 'react';
import CgCnGoodSelector from 'modules/CbamQuote/components/CgCnGoodSelector';
import { useTranslation } from 'react-i18next';

// CBAM CN-goods picker. Defers to the existing CgCnGoodSelector — that
// component owns the catalogue + autocomplete behavior and we don't want
// to duplicate it. Wraps it as a Controller-compatible field so call sites
// inside a v2 Form can use it the same way as TextField/SelectField.
export default function GoodsSelectField({
  field,
  fieldState,
  id,
  placeholder,
  disabled,
  showSelectedSubtitle = false,
  controlMinHeight = 38,
  useAutonomousData = true,
  // Pass-through for CgCnGoodSelector: render "CN Code - Name" as the
  // selected value instead of just the CN code pill.
  showCnName = false,
  // Pass-through for CgCnGoodSelector: limit the option list to a subset
  // of CN good IDs (e.g. only goods with actual emission factors).
  filterByCnGoodIds = null,
}) {
  const { t } = useTranslation('common');
  const resolvedPlaceholder =
    placeholder ?? t('common:fields.selectCbamGoodPlaceholder', 'Select a CBAM good');
  return (
    <div
      id={id}
      className={fieldState?.error ? 'cg-good-select-error' : ''}
    >
      <CgCnGoodSelector
        value={field.value || ''}
        onChange={(v) => field.onChange(v || '')}
        placeholder={resolvedPlaceholder}
        disabled={disabled}
        showSelectedSubtitle={showSelectedSubtitle}
        controlMinHeight={controlMinHeight}
        useAutonomousData={useAutonomousData}
        showCnName={showCnName}
        filterByCnGoodIds={filterByCnGoodIds}
        error={fieldState?.error?.message}
      />
    </div>
  );
}
